/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import * as yup from 'yup'

const ValidationSchema = () => {
  yup.setLocale({
    mixed: {
      required: 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR'
    },
    string: {
      max: 'FORM_VALIDATION_ERROR_MAX_LENGTH_IS_${max}'
    }
  })

  return yup.object().shape({
    userSettings: yup.object().shape({
      locale: yup
        .string()
        .max(255)
        .required()
        .nullable()
        .default(() => ''),
      dateFormat: yup
        .string()
        .max(255)
        .required()
        .nullable()
        .default(() => ''),
      timeFormat: yup
        .string()
        .max(255)
        .nullable()
        .required()
        .default(() => ''),
      timeFormat24h: yup
        .boolean()
        .nullable()
        .default(() => false)
    }),
    notifSettings: yup.array().default(() => [])
  })
}

export default ValidationSchema
